import React, { useMemo } from 'react';
import {loadStripe} from '@stripe/stripe-js';
import {CardElement, Elements, ElementsConsumer, useStripe, useElements,} from '@stripe/react-stripe-js';
// import '../styles/common.css';
import './styles.css'
import useResponsiveFontSize from "./useResponsiveFontSize";
import axios from "axios";
import {BACKEND_BASE_URL} from "../../constants/routes";


const useOptions = () => {
    const fontSize = useResponsiveFontSize();
    const options = useMemo(
        () => ({
            style: {
                base: {
                    fontSize,
                    color: "#424770",
                    letterSpacing: "0.025em",
                    fontFamily: "Source Code Pro, monospace",
                    "::placeholder": {
                        color: "#aab7c4"
                    }
                },
                invalid: {
                    color: "#9e2146"
                }
            }
        }),
        [fontSize]
    );

    return options;
};

const CARD_ELEMENT_OPTIONS = {
    style: {
        base: {
            color: "#32325d",
            fontFamily: '"Helvetica Neue", Helvetica, sans-serif',
            fontSmoothing: "antialiased",
            fontSize: "16px",
            "::placeholder": {
                color: "#aab7c4",
            },
        },
        invalid: {
            color: "#fa755a",
            iconColor: "#fa755a",
        },
    },
    hidePostalCode:true
};

class CheckoutForm extends React.Component {


    componentDidMount() {
        axios.get(`${BACKEND_BASE_URL}/users/user-by-id?userId=${this.props.user.userId}`).then(data=>{
            console.log(data.data.user.commission)
            let user  = data.data.user
            this.dueAmount = user.commission;
            this.setState({
                dueAmount : data.data.user.commission
            })
        }).catch(error=>{
            console.log(error)
        })
    }

    constructor(props) {
        super(props);
        this.handleSubmit = this.handleSubmit.bind(this)
        // this.pay = this.pay(this)
        console.log( `${this.props.user.firstName} ${this.props.user.lastName}`)
        this.state = {
            dueAmount : 0
        }


    }


    pay = async(clientSecret)=>{

        const {stripe, elements} = this.props;

        if (!stripe || !elements) {
            // Stripe.js has not loaded yet. Make sure to disable
            // form submission until Stripe.js has loaded.
            console.log("not loaded");
            return;
        }



        const result = await stripe.confirmCardPayment(clientSecret, {
            payment_method: {
                card: elements.getElement(CardElement),
                billing_details: {
                    name:`${this.props.user.firstName} ${this.props.user.lastName}`,
                },
            }
        });

        if (result.error) {
            // Show error to your customer (e.g., insufficient funds)
            console.log(result.error.message);
        } else {
            // The payment has been processed!
            if (result.paymentIntent.status === 'succeeded') {
                // Show a success message to your customer
                // There's a risk of the customer closing the window before callback
                // execution. Set up a webhook or plugin to listen for the
                // payment_intent.succeeded event that handles any business critical
                // post-payment actions.
                console.log("success");
                console.log(result);
                alert("Your Payment was Successful")

            }else{
                alert("There was an error with Your Payment")
            }
        }
    }

    handleSubmit = async (event) => {
        // Block native form submission.
        event.preventDefault();

        // region Create Payment Intent on  Server
        axios.post(`${BACKEND_BASE_URL}/pay/create-payment`, {
            "amount": this.state.dueAmount,
            "userId": this.props.user.userId
        }).then(data=>{
            // console.log(data.data.clientSecret)
            this.pay(data.data.clientSecret)
        }).catch(error=>{

        })


        // // Get a reference to a mounted CardElement. Elements knows how
        // // to find your CardElement because there can only ever be one of
        // // each type of element.
        // const cardElement = elements.getElement(CardElement);
        //
        // const {error, paymentMethod} = await stripe.createPaymentMethod({
        //     type: 'card',
        //     card: cardElement,
        // });
        //
        // if (error) {
        //     console.log('[error]', error);
        // } else {
        //     console.log('[PaymentMethod]', paymentMethod);
        // }
    };

    render() {
        const {stripe} = this.props;
        return (
            <div className={"container text-center"}>
                <p style={{"font-family": "Roboto", padding: "20px"}}>
                    Hey, {this.props.user.firstName}, Hope you have enjoyed Using Our Services so far, as all Supworkers pay 20% commission
                    on each Job. Please make your payment below.
                </p>
                <form className={"text-center"} style={{margin: "0 auto",  width: "500px", "font-family": "Roboto, Open Sans, Segoe UI, sans-serif"}} onSubmit={this.handleSubmit}>
                    <CardElement
                        options={CARD_ELEMENT_OPTIONS}
                    />

                    <input type={"text"} style={{margin: "10 auto", width: "50px", "font-family": "Roboto, Open Sans, Segoe UI, sans-serif"}}value={`${this.state.dueAmount} TL`} disabled={true}/>

                    <button type="submit" disabled={!stripe} style={{margin: "0 auto", width: "500px"}} >
                        Pay
                    </button>
                </form>
            </div>

        );
    }
}



const InjectedCheckoutForm = () => {
    return (
        <ElementsConsumer>
            {({elements, stripe}) => (
                <CheckoutForm elements={elements} stripe={stripe} />
            )}
        </ElementsConsumer>
    );
};

// Make sure to call `loadStripe` outside of a component’s render to avoid
// recreating the `Stripe` object on every render.
const stripePromise = loadStripe('pk_test_6pRNASCoBOKtIshFeQd4XMUh');

export default CheckoutForm